import api from "./baseApi.js";

export default {
  
  GetCategory(Id) {
    return api.get("Request/GetCategory/" + Id);
  },

  GetCategoriesList() {
    return api.get("Request/GetCategoriesList");
  },

  GetVehiclesTypes() {
    return api.get("Request/GetVehiclesTypes");
  },

  GetWarranties(buId) {
    if (buId)
      return api.get("Request/GetWarranties/" + buId);
        else
      return api.get("Request/GetWarranties");
  },

  GetStatuses(all) {
    return api.get("Request/GetStatuses/" + all);
  },

  AddCategory(category) {
    return api.post("Request/SaveCategory", category);
  },

  GetRequest(Id) {
    return api.get("Request/GetRequest/" + Id);
  },

  AddRequest(request) {
    return api.post("Request/AddRequest", request);
  },

  Get(url, arg, type) {
    if (type == "post")
      return api.post(url, arg);
    else
      return api.get(url + "/" +arg);
  },
}